import React, { useEffect, useState } from "react";

/**
 * Affiche un PDF dans la page, avec la visionneuse du navigateur.
 *
 * L'URL locale du fichier est libérée au démontage : la modale remet son
 * contenu à null en se fermant, donc chaque aperçu fermé rend sa mémoire.
 */
const ApercuPdf = ({ blob, titre }) => {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    const urlLocale = URL.createObjectURL(
      new Blob([blob], { type: "application/pdf" }),
    );
    setUrl(urlLocale);

    return () => URL.revokeObjectURL(urlLocale);
  }, [blob]);

  if (!url) return null;

  return (
    <iframe
      title={titre}
      src={url}
      style={{ width: "100%", height: "75vh", border: 0 }}
    />
  );
};

export default ApercuPdf;
